import React from 'react';

import styles from './MarketingCarouselCard.module.scss';

interface MarketingCarouselCardProps {
  title: string;
  subTitle?: string;
  productLogoUrl?: string;
  carouselImageUrl: string;
  ctaLabel: string;
  termsText?: string;
  carouselImageBackgroundColor: string;
}

const MarketingCarouselCard: React.FC<MarketingCarouselCardProps> = ({
  title,
  subTitle,
  productLogoUrl,
  carouselImageUrl,
  ctaLabel,
  termsText,
  carouselImageBackgroundColor,
}) => {
  return (
    <div className={styles.marketingCarouselCard}>
      <div className={styles.leftColumn}>
        {productLogoUrl && (
          <img src={productLogoUrl} alt='Product Logo' className={styles.productLogo} />
        )}
        <div className={styles.contentWrapper}>
          <div title={title} className={styles.title}>
            {title}
          </div>
          {subTitle && (
            <div title={subTitle} className={styles.subtitle}>
              {subTitle}
            </div>
          )}
          <div title={ctaLabel} className={styles.ctaButton}>
            <span className={styles.ellipsis}>{ctaLabel}</span>
          </div>
        </div>
      </div>

      <div className={styles.rightColumn}>
        {carouselImageUrl && (
          <div className={styles.imageContainer}>
            <img src={carouselImageUrl} alt={title} className={styles.carouselImage} />
            <div
              className={styles.rotatedBackground}
              style={{ backgroundColor: carouselImageBackgroundColor }}
            />
          </div>
        )}
        {termsText && <div className={styles.tag}>{termsText}</div>}
      </div>
    </div>
  );
};

export default MarketingCarouselCard;
